module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_1.9e065c03.png";